import React from "react";
import { Helmet } from "react-helmet";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import BackButton from "../../backButton";
import maklaanit1 from "../../../assets/images/maklaanit1.jpeg";
import maklaanit2 from "../../../assets/images/maklaanit2.jpeg";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Maklaanit = () => {
  return (
    <div className="inner-section" id="maklaanit">
      <Helmet>
        <title>פטרידע - הפטריה מקלענית</title>
        <meta
          name="description"
          content="הפטריה מקלענית - Sphaerobolus: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="maklaanit" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="maklaanitText1" />
          </p>
          <p>
            <MultiLingualContent contentID="maklaanitText2" />
          </p>
          <br />
          <p>
            <b>
              <MultiLingualContent contentID="maklaanitText3Bold" />
            </b>
          </p>
          <p>
            <MultiLingualContent contentID="maklaanitText4" />
          </p>
          <p>
            <MultiLingualContent contentID="maklaanitText5" />
          </p>
          <p>
            <MultiLingualContent contentID="maklaanitText6" />
          </p>
          <div className="informationImages">
            <div className="imgWrapper">
              <LazyLoadImage src={maklaanit1} alt="מקלענית" />
              <p>
                <MultiLingualContent contentID="maklaanitImg1" />
              </p>
            </div>
            <div className="imgWrapper">
              <LazyLoadImage src={maklaanit2} alt="מקלענית" />
              <p>
                <MultiLingualContent contentID="maklaanitImg2" />
              </p>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Maklaanit;
